// stores/peopleModalStore.ts
import { defineStore } from 'pinia'
import type { SearchResultOpenPositionItem } from '~/types/SearchResultItem'

export const useOpenPositionModal = defineStore('openPositionModal', {
  state: () => ({
    items: [] as SearchResultOpenPositionItem[],
    showAll: false,
    size: 9,
    layoutIsFullList: false,
    unMutableLayoutIsFullList: false,
    searchValue: '',
    selectedCategory: '' as string,
    careerCategories: [] as string[],
    openAsModal: false,
    isGrid: true,
    totalResults: 0,
    locations: [] as any[],
    departments: [] as string[],
    positions: [] as string[],
    selectedLocation: '',
    selectedDepartment: '',
    selectedSortValue: 'asc',
    readMore: false
  }),
  actions: {
    resetStates() {
      this.items = []
      this.showAll = false
      this.size = 9
      this.layoutIsFullList = false
      this.unMutableLayoutIsFullList = false
      this.searchValue = ''
      this.selectedCategory = ''
      this.careerCategories = []
      this.openAsModal = false
      this.isGrid = true
      this.totalResults = 0
      this.locations = []
      this.departments = []
      this.positions = []
      this.selectedLocation = ''
      this.selectedDepartment = ''
      this.selectedSortValue = 'asc'
      this.readMore = false
    },
    setItems(items: SearchResultOpenPositionItem[]) {
      this.items = items
    },

    setCareerCategories(categories: string[]) {
      this.careerCategories = categories
    },
    setDepartments(departments: string[]) {
      this.departments = departments
    },
    setLocations(locations: any[]) {
      this.locations = locations
    },
    setSearchValue(value: string) {
      this.searchValue = value
    },
    setSize(size: number) {
      this.size = size
    },
    setViewAllPreview() {
      this.openAsModal = true
      this.size = 12
      this.layoutIsFullList = true
      //this.clearFilters();
    },
    setCloseViewAll() {
      if (!this.openAsModal) {
        return
      }
      //this.clearFilters();
      if (!this.unMutableLayoutIsFullList) {
        this.size = 9
        this.layoutIsFullList = false
      } else {
        this.size = this.totalResults
      }
      this.isGrid = true
      this.openAsModal = false
    },
    clearFilters() {
      this.selectedCategory = ''
      this.searchValue = ''
      this.selectedDepartment = ''
      this.selectedLocation = ''
      usePaginationStore().changePage(1)
    },
    setSelectedLocation(location: string) {
      usePaginationStore().changePage(1)
      this.selectedLocation = location
    },
    setSelectedDepartment(department: string) {
      usePaginationStore().changePage(1)
      this.selectedDepartment = department
    },
    setSelectedCategory(selectedCategory: string) {
      usePaginationStore().changePage(1)
      this.selectedCategory = selectedCategory
    },
    setIsGrid(isGrid: boolean) {
      this.isGrid = isGrid
    },
    setSortValue(sortValue: string) {
      this.selectedSortValue = sortValue
    },
    setReadMore(read: boolean) {
      this.readMore = read
    },
    addItems(items: SearchResultOpenPositionItem[]) {
      this.items = this.items.concat(items)
    },
    setTotalResults(totalResults: number) {
      this.totalResults = totalResults
    }
  }
})
